import { render } from "./MENA.vue?vue&type=template&id=a6695186"
import script from "./MENA.vue?vue&type=script&lang=js"
export * from "./MENA.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__